import { HStack, Text } from '@chakra-ui/react';
import React from 'react';
import { extra } from '@/theme/colors/palettes';
import MYOMagicWand from '@/components/icons/MYOMagicWand';

const AIGeneratedLabel = () => {
  return (
    <HStack
      position={'relative'}
      alignItems={'center'}
      justifyContent={'center'}
      backgroundColor={'gray.400'}
      paddingX={'6px'}
      paddingY={'4px'}
      borderRadius={'8px'}
      gap={'4px'}
    >
      <MYOMagicWand size={14} />
      <Text variant={'urbanistMaximumBold10'} color={extra.white}>
        AI GENERATED
      </Text>
    </HStack>
  );
};

export default AIGeneratedLabel;
